module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-05-aff944b8874dae4c4de9f3f60dbd2c6d.jpg";